import { InfoSet } from "../InfoSets/InfoSet";
import { Device } from "../Core/Device";
import { Dictionary } from "../Utils/Dictionary";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

//export interface InstalledSoftwareEntryJsonWrapper {
//    installed_sw_entry: InstalledSoftwareEntryJson;
//}

//export interface InstalledSoftwareEntryJson {
//	index: string;
//    name: string;
//    id: string;
//    type: string;
//    install_date: string;
//    version: string;
//}

export class InstalledSoftwareEntry implements ObjectSerializer {
 //   public static FromJson(entry: InstalledSoftwareEntryJson): InstalledSoftwareEntry {

 //       var swIndex = NumberUtils.ToNumber(entry.index);

 //       var result = new InstalledSoftwareEntry(swIndex);

 //       result.Name = entry.name;
 //       result.ID = entry.id;
 //       result.SoftwareType = NumberUtils.ToNumber(entry.type);

 //       // CONVERT the time
 //       var ticks = NumberUtils.ToNumber(entry.install_date);
 //       if (ticks > 0) {
 //           //ticks are in nanotime; convert to microtime
 //           var ticksToMicrotime = ticks / 10000;
 
 //           //ticks are recorded from 1/1/1; get microtime difference from 1/1/1/ to 1/1/1970
 //           var epochMicrotimeDiff = 2208988800000;
 
 //           //new date is ticks, converted to microtime, minus difference from epoch microtime
 //           var tickDate = new Date(ticksToMicrotime - epochMicrotimeDiff);

 //           result.InstallDate = tickDate;
 //       }

 //       result.Version = entry.version;

	//	return result;
	//}

	public Index: number;

	public Name: string;
	public get HasName() {
		return !!this.Name;
    }

    public ID: string;
    public get HasID() {
        return !!this.ID;
    }

    public SoftwareType: number;
    public get HasSoftwareType(): boolean {
        return this.SoftwareType > 0;
    }
    public get SoftwareTypeToString(): string {
        var typeStr = "Invalid";

        switch (this.SoftwareType) {
            case 1: typeStr = "Unknown"; break;
            case 2: typeStr = "OperatingSystem"; break;
            case 3: typeStr = "DeviceDriver"; break;
            case 4: typeStr = "Application"; break;
        }

        return typeStr;
    }

    public InstallDate: number;
	public get HasInstallDate() {
		return (this.InstallDate >= 0);
	}

    public Version: string;
    public get HasVersion() {
        return !!this.Version;
    }

	constructor(swIndex?: number) {
		this.Index = swIndex;
        this.Name = '';
        this.ID = '';

		this.SoftwareType = 1;
		this.InstallDate = -1;
        this.Version = '';
	}

	public Write(obj: any, context: any): void {
		obj.installed_sw_entry = {};
		obj = obj.installed_sw_entry;

		obj.index = ValueEncoder.EncodeInteger(this.Index);

		if (this.HasName)
			obj.name = this.Name;

		if (this.HasID)
			obj.id = this.ID;

		if (this.HasSoftwareType)
			obj.type = ValueEncoder.EncodeInteger(this.SoftwareType);

		if (this.HasInstallDate)
			obj.install_date = ValueEncoder.EncodeInteger(this.InstallDate);

		if (this.HasVersion)
			obj.version = this.Version;
	}

	public Read(obj: any, context: any): void {
		if (!obj.installed_sw_entry)
			throw new Error();
		obj = obj.installed_sw_entry;

		if (obj.index !== undefined)
			this.Index = ValueEncoder.DecodeInteger(obj.index);

		if (obj.name !== undefined)
			this.Name = obj.name;

		if (obj.id !== undefined)
			this.ID = obj.id;

		if (obj.type !== undefined)
			this.SoftwareType = ValueEncoder.DecodeInteger(obj.type);

		if (obj.install_date !== undefined)
			this.InstallDate = ValueEncoder.DecodeInteger(obj.install_date);

		if (obj.version !== undefined)
			this.Version = obj.version;
	}
}

export class InstalledSoftwareTable extends InfoSet {
 //   public static FromJson(json: InfoSetEntriesJson<InstalledSoftwareEntryJsonWrapper>, device: Device): InstalledSoftwareTable {
	//	var result = new InstalledSoftwareTable(device);

	//	json.entries.forEach((jsonEntry) => {
 //           result.AddEntry(InstalledSoftwareEntry.FromJson(jsonEntry.installed_sw_entry));
	//	});

	//	return result;
	//}

    public ToArray(): InstalledSoftwareEntry[] {
        return this._swTable.Values().Values;
	}

    private _swTable: Dictionary<number, InstalledSoftwareEntry>;

	constructor(device: Device) {
		super(device);
        this._swTable = new Dictionary<number, InstalledSoftwareEntry>();
	}

    public Add(swIndex: number): InstalledSoftwareEntry {
        var swEntry: InstalledSoftwareEntry = this._swTable.Item(swIndex);
			
        if (!swEntry) {
            swEntry = new InstalledSoftwareEntry(swIndex);
			this._swTable.Add(swIndex, swEntry);
		}

        return swEntry;
	}

    public AddEntry(swEntry: InstalledSoftwareEntry): void {
        if (!swEntry)
			return;

        if (swEntry.Index < 0)
			return;

		this._swTable.Remove(swEntry.Index);
		this._swTable.Add(swEntry.Index, swEntry);
	}

	public Clear():void {
        this._swTable.Clear();
	}

	public get Count():number {
        return this._swTable.Count;
	}

    public Find(swIndex: number): InstalledSoftwareEntry {
		return this._swTable.Item(swIndex);
	}

	public RemoveByIndex(swIndex:number):boolean{
		return this._swTable.Remove(swIndex);
	}

    public Remove(swEntry: InstalledSoftwareEntry): boolean{
		return swEntry ? this._swTable.Remove(swEntry.Index) : false;
	}

    public ForEach(callbackfn: (value: InstalledSoftwareEntry, index: number, array: InstalledSoftwareEntry[]) => void, thisArg?: any): void {
		this._swTable.Values().ForEach(callbackfn, thisArg);
	}

    public Some(callbackfn: (value: InstalledSoftwareEntry, index: number, array: InstalledSoftwareEntry[]) => boolean, thisArg?: any): boolean {
		return this._swTable.Values().Some(callbackfn, thisArg);
	}

	public Write(obj: any, context: any): void {
		obj.inst_sw_info = {};
		obj = obj.inst_sw_info;

		obj.entries = [];
		ObjSerUtils.WriteObjSerCollection(obj.entries, this._swTable.Values(), context);
	}

	public Read(obj: any, context: any): void {
		if (!obj.inst_sw_info)
			throw new Error();
		obj = obj.inst_sw_info;

		this.Clear();

		if (obj.entries !== undefined) {
			obj.entries.forEach((value: any) => {
				let entry = new InstalledSoftwareEntry();
				entry.Read(value, context);
				this.AddEntry(entry);
			}, this);
		}
	}

}
